import { AdminToolSkeleton } from '../../AdminToolSkeleton';
import { PaginatedTable, PaginatedTableProps } from '@act/storybook';
import { CategoriesTableColumns } from './CategoriesColumns';
import { IndexChildContainer } from 'react-components/member-index/indexContainer';
import { useAppNavigation } from 'react-components/app/routing/routes';
import { clientAppSelectors } from 'redux/slices/clientSlice';
import { getAllClients } from 'redux/slices/clientSlice';
import { messageTemplatesSelectors } from 'redux/slices/messageTemplatesSlice';
import { useEffect, useMemo, useState } from 'react';
import { useAppDispatch } from 'redux/store-hooks';
import { MessageTemplateCategoryAdminDto } from '@act/shared/data-transfer-objects';
import { MessageCategoriesCreateEdit } from './MessageCategoriesCreateEdit';

export const MessageTemplateCategoriesTable = () => {
  const navigate = useAppNavigation();
  const dispatch = useAppDispatch();
  const [categoryEdit, setCategoryEdit] = useState(false);
  const [categoryCreate, setCategoryCreate] = useState(false);
  const [selectedCategory, setSelectedCategory] =
    useState<MessageTemplateCategoryAdminDto | null>(null);

  const setFormOpen = (value: boolean) => {
    if (!value) {
      setCategoryEdit(false);
      navigate.toAllMessageCategories();
    }
  };

  const messageCategories = Object.values(
    messageTemplatesSelectors.useSelectAll().entities
  );
  const allClients = clientAppSelectors.useSelectAllClients();
  const clientList = useMemo(
    () => allClients.ids.map(id => allClients.entities[id]),
    [allClients]
  );
  useEffect(() => {
    if (clientList.length === 0) {
      dispatch(getAllClients({}));
    }
  }, []);

  const MESSAGE_CATEGORIES_TEMPLATES_ADMIN_TABLE_PROPS: PaginatedTableProps<MessageTemplateCategoryAdminDto> =
    {
      data: messageCategories.sort((a, b) => a.sortOrder - b.sortOrder),
      columnConfig: CategoriesTableColumns(),
      inMemoryPagination: true,
      onRowClick: messageCategory => {
        setSelectedCategory(messageCategory);
        setCategoryEdit(true);
      },
    };

  return (
    <>
      <AdminToolSkeleton
        title="All Message Categories"
        toolDescription="Message categories can be viewed and updated here."
        buttonContent="Add New Message Category"
        variant="contained"
        onClick={() => setCategoryCreate(true)}
      >
        <IndexChildContainer>
          <PaginatedTable {...MESSAGE_CATEGORIES_TEMPLATES_ADMIN_TABLE_PROPS} />
        </IndexChildContainer>
        {(categoryCreate || categoryEdit) && (
          <MessageCategoriesCreateEdit
            open={categoryCreate || categoryEdit}
            isEdit={categoryEdit}
            setOpen={categoryCreate ? setCategoryCreate : setFormOpen}
            selectedCategory={categoryEdit ? selectedCategory : undefined}
          />
        )}
      </AdminToolSkeleton>
    </>
  );
};
